import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";

interface ILoadingButtonProps {
    loading?: boolean;
    loadingIndicatorSize?: number;
}

export type LoadingButtonProps = ILoadingButtonProps & ButtonProps;

export const LoadingButton = ({
    children,
    loading,
    loadingIndicatorSize = 25,
    onClick,
    ...rest
}: LoadingButtonProps) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (onClick && !loading) {
            onClick(e);
        }
    };

    return (
        <Button onClick={handleClick} {...rest}>
            {loading ? (
                <CircularProgress color="inherit" size={loadingIndicatorSize} />
            ) : (
                children
            )}
        </Button>
    );
};

export type LoadingIconButtonProps = ILoadingButtonProps & IconButtonProps;

export const LoadingIconButton = ({
    children,
    loading,
    loadingIndicatorSize = 25,
    onClick,
    ...rest
}: LoadingIconButtonProps) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (onClick && !loading) {
            onClick(e);
        }
    };

    return (
        <IconButton onClick={handleClick} {...rest}>
            {loading ? (
                <CircularProgress color="inherit" size={loadingIndicatorSize} />
            ) : (
                children
            )}
        </IconButton>
    );
};
